// Depends
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, professionalMeta('Lista de endereços')),
  route('create', '/create', Form, professionalMeta('Adicionar endereço')),
  route('edit', '/:id/edit', Form, professionalMeta('Editar endereço'))
]

export default subGroup('/addresses', routes)



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/routes.js